import React, { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Tab, Tabs, Children, Container } from './DomainTabs.styles';
import { TabButton, TabsCont } from '../../components/TabGroup/TabGroup.styles';
import { CreateSurveyCardsNames, CreateSurveyTypeNames } from '../../constans/state';

interface IDomainTabs {
  surveyOverviewType: string;
  defaultTab: string;
  defaultDomain: string;
  applyFilters: (filters: any) => void;
  children: ReactElement;
}

export const clearedFilters = {
  pageNo: null,
  sortOrder: null,
  perPage: null,
  addTeam: null,
  compare: null,
  compareSort: null,
  activeSection: null,
  surveyReport: null,
  prm: null,
  riskAnalysis: null,
  predictiveStates: null,
  search: null,
  language: null,
  reports: null,
};

const DomainTabs: FC<IDomainTabs> = ({
  surveyOverviewType,
  defaultTab,
  defaultDomain,
  applyFilters,
  children,
}) => {
  const showContentsTabs =
    surveyOverviewType === 'EFFECT' && defaultTab === CreateSurveyCardsNames.contents;

  const showReportsTabs = defaultTab === CreateSurveyCardsNames.participantsandreports;

  const { t } = useTranslation();

  const getApplyFilters = (card: string) => (domain: string) => () =>
    applyFilters({
      ...clearedFilters,
      card,
      domain,
    });

  const isActive = (domain: string) => defaultDomain === domain;

  if (showContentsTabs) {
    const getApplyContentsFilters = getApplyFilters('contents');

    const internalName = CreateSurveyTypeNames.internal;
    const externalName = CreateSurveyTypeNames.external;

    return (
      <Container>
        <Tabs>
          <Tab onClick={getApplyContentsFilters(internalName)} active={isActive(internalName)}>
            {t('viewSurvey.topBar.internal')}
          </Tab>
          <Tab onClick={getApplyContentsFilters(externalName)} active={isActive(externalName)}>
            {t('viewSurvey.topBar.external')}
          </Tab>
        </Tabs>
        <Children>{children}</Children>
      </Container>
    );
  }

  if (showReportsTabs) {
    const getApplyReportsFilters = getApplyFilters('participantsandreports');

    const participantsName = CreateSurveyTypeNames.participants;
    const reportsName = CreateSurveyTypeNames.reportsSetup;

    return (
      <Container>
        <TabsCont defaultValue={t('viewSurvey.topBar.participants')} data-testid="tabsContainer">
          <TabButton
            onClick={getApplyReportsFilters(reportsName)}
            isSelected={reportsName === defaultDomain}
            data-testid="tab"
          >
            {t('viewSurvey.topBar.reportsSetup')}
          </TabButton>
          <TabButton
            onClick={getApplyReportsFilters(participantsName)}
            isSelected={participantsName === defaultDomain}
            data-testid="tab"
          >
            {t('viewSurvey.topBar.participants')}
          </TabButton>
        </TabsCont>
        {children}
      </Container>
    );
  }

  return <Container>{children}</Container>;
};

export default DomainTabs;
